$.fn.jeSuisFan = function(options) {
  let self = this;

  // Je suis fan
  self.find("a.fan-button").on("click", function() {
    var object_id = $(this).attr("data-object-id"),
      nonce = $(this).attr("data-nonce"),
      self = $(this);
    if (!self.hasClass("liked")){
      self.removeClass("unliked").addClass("liked");
      self.parent().find(".fan-status").addClass("visible");
      self.parent().find(".fan-newsletter").slideDown("fast");
    } else {
      self.parent().find(".fan-status").removeClass("visible");
      self.parent().find(".fan-newsletter").slideUp("fast");
      self.removeClass("liked").addClass("unliked").on("mouseexit mouseout", function(){
        $(this).removeClass("unliked");
      });
    }
    jQuery.ajax({
      type: "post",
      dataType: "json",
      url: "/wp/wp-admin/admin-ajax.php",
      data: {
        action: "object_like",
        object_id: object_id,
        nonce: nonce
      },
      success: function(response) {
        //
      }
    });
    return false;
  });

  self.find("button.close").on("click", function(){
    $(".fan-newsletter").slideUp("fast");
  });

  self.find(".newsletter-subscribe__submit").on("click", function(){
    self.find("form.newsletter-subscribe").submit();
  });

  self.find("form.newsletter-subscribe").on("submit", function(){
    $("p.success").slideUp("fast");
    var newsletter_email = $("input[name=newsletter_email]").val(),
      self = $(this);
    if (newsletter_email != ""){
      self.addClass("saving");
      jQuery.ajax({
        type: "post",
        dataType: "json",
        url: self.attr("action"),
        data: {
          action: "newsletter",
          newsletter_email: newsletter_email
        },
        success: function(response) {
          if (response.success){
            self.removeClass("saving").addClass("saved");
            if (self.hasClass("in-footer")){
              $("input[name=newsletter_email]").val("").blur();
              var successMessage = $("<p class='success'><strong>Inscription à l'infolettre réussie! Merci.</strong></p>").hide();
              self.append(successMessage);
              successMessage.slideDown();
            } else {
              self.find('.icon-arrow-down').html('✓').removeClass('icon-arrow-down').addClass('success');
            }
          } else {
            self.removeClass("saving");
            $("input[name=newsletter_email]").val("");
          }
        }
      });
    }
    return false;
  });

  return function() {
    return self
  }()
}
